// socket.js
import { io } from "socket.io-client";

const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api";

export const createSocket = (userId) => {
  return io(baseUrl.replace('/api', ''), {
    auth: { userId }
  });
  // return io(baseUrl.replace('/api', ''));
};